import { Injectable, inject } from '@angular/core';
import { SsApiService } from '../api/ss-api.service';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastMessageService } from '../../shared/modules/toast-message/toast-message.service';
import { ModalService } from '../../modal/modal.service';

@Injectable({
  providedIn: 'root',
})
export class UserCompPointsService {
  private _api = inject(SsApiService);
  private _toastMessage = inject(ToastMessageService);
  private _modals = inject(ModalService);


  /**
   * Comp points exchange button click handler
   */
  compPointsExchange() {
    this.getMoneyExchangeRate().pipe(
      tap(e => {
        if (e) {
          this._loadCompPointsExchangeModal();
        } else {
          this._toastMessage.error('t.exchange-not-available');
        }
      }),
    ).subscribe();
  }

  /**
   * Returns user comp points data
   */
  getCompPoints(): Observable<any> {
    return this._api.playerCompPoints().pipe(
      map((points) => this.mapCompPoints(points)),
      catchError(error => of({})),
    );
  }

  /**
   * Returns money exchange rate for comp points
   */
  getMoneyExchangeRate(): Observable<any> {
    return this._api.compPointsRatesMoney().pipe(
      map(rateList => rateList[0]),
      catchError(error => of(null)),
    );
  }

  /**
   * Exchange comp points to money
   *
   * @param data
   */
  exchangeToMoney(data: object): Observable<any> {
    return this._api.compPointsExchangeMoney({
      exchange: data,
    });
  }

  public mapCompPoints(compPoints: any): any {
    return {
      ...compPoints,
      chargeable: compPoints.chargeable?.points || 0,
      persistent: compPoints.persistent?.points || 0,
    };
  };

  private async _loadCompPointsExchangeModal() {
    const component = await import('../../../core/modal/components/lazy/comp-points-exchange-modal/comp-points-exchange-modal.component');
    await this._modals.openLazy(component?.CompPointsExchangeModalComponent);
  }
}
